<app-loader [loading]="isLoading"></app-loader>
<div class="container-fluid">
    <div class="row">
        <div class="col-xl-7"
            style="background-image: url('assets/superadmin/login/safetyGroup.jpeg'); background-size: cover; background-position: center center; display: block;">
        </div>
        <div class="col-xl-5 p-0">
            <div class="login-card login-dark">
                <div>
                    <div>
                        <app-theme-mode></app-theme-mode>
                    </div>
                    <div>
                        <a class="logo" [routerLink]="['/home']">
                            <img class="img-fluid for-light img-logo" src="assets/superadmin/logo/logo.png"
                                alt="loginPage">
                            <img class="img-fluid for-dark img-logo" src="assets/superadmin/logo/logo.png"
                                alt="loginPage">
                        </a>
                    </div>
                    <div>
                        <app-login-form></app-login-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>